import { useTranslation } from 'react-i18next';

export default function PrologueSection() {
  const { t } = useTranslation();

  return (
    <section id="prologue" className="py-20 md:py-24 bg-[#06121F]">
      <div className="max-w-5xl mx-auto px-6">
        {/* 見出し（「神域の間」- 余白を十分に） */}
        <h2 className="text-center font-serif text-2xl md:text-3xl tracking-[0.18em] text-white">
          {t('prologue.heading')}
        </h2>
        <p className="mt-4 text-center text-white/70">
          {t('prologue.subheading')}
        </p>

        {/* YouTube埋め込み */}
        <div className="mt-12 aspect-video overflow-hidden rounded-2xl border border-white/10 bg-black/20 backdrop-blur">
          <iframe
            className="h-full w-full"
            src="https://www.youtube.com/embed/uFEA0zvw0MQ"
            title="GREAT HERO'S JOURNEY PROLOGUE"
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
